import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {LuLayoutDashboard} from "react-icons/lu";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import {MdEditSquare} from "react-icons/md";
import API from "../../Services/API";

function UploadExcelReturn() {

    const [documentFile, setDocumentFile] = React.useState(null);
    const onDocChange = (event) => {
        setDocumentFile(event.target.files[0])
    }
    const onUploadClick = () => {
        const formData = new FormData();
        const file = documentFile;

        if (file) {
            if(file.size > 2485760) {
                toast.error('حجم فایل ارسالی نمی تواند بیشتر از 2 مگابایت باشد');
                return false;
            }
            formData.append('excel_file', file);

        } else {
            toast.error('لطفا ابتدا یک فایل معتبر انتخاب کنید!');
            return false;
        }


        API.uploadFileReturnByExcel(formData)
            .then((response) => {
                toast.success(response.message);

            })
            .catch((error) => {
                toast.error(error.response.data.message)
            });
    }
    return (
        <React.Fragment>
            <Header/>
            <Navbar page="batchreturn"/>
            <Toast/>
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <LuLayoutDashboard className='ms-2' />
                    مرجوع کردن باتری ها با فایل اکسل
                    </h1>

                </div>

                <section className="section dashboard">
                    <div className="row rtl">
                        <div className="col--12">

                            <div className="card info-card customers-card">


                                <div className="card-body">


                                    <div className="d-flex align-items-center">
                                        <p className='p-2 mt-4 fw-bold text-muted border-bottom pb-3 w-100'>
                                            <MdEditSquare className='mx-2 text-success text-big-3'/>
                                            برای مرجوع کردن باتری ها کد باتری معیوب، کد باتری جایگزین و تاریخ مرجوعی را در قالب یک فایل
                                            اکسل ارسال بفرمایید.
                                            <a href="https://api.ngkh.ir/storage/app/media/Batch-Return.xlsx" target="_blank"
                                               className='mx-3 text-decoration-underline' rel="noreferrer">
                                                دانلود فایل اکسل نمونه
                                            </a>
                                        </p>


                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 ">
                                            <label className="custom-file-upload">
                                                انتخاب فایل اکسل
                                                <input type="file" onChange={onDocChange}
                                                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                />
                                            </label>

                                            <div
                                                className=" text-success text-small-2  bg-light mt-2 p-1 text-center">
                                                &nbsp;
                                                {
                                                    documentFile ?
                                                        " فایل انتخاب شده : " +
                                                        documentFile.name
                                                        : ''
                                                }
                                            </div>
                                        </div>

                                        <div className="col-md-6 text-left mt-3">
                                            <button className="btn btn-warning  w-100"
                                                    onClick={onUploadClick}>

                                                آپلود فایل

                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default UploadExcelReturn;